import styled from 'styled-components';
import { NiceBlue, Bluish, WhiteFour, DarkSkyBlue } from '../../styles/Colours';
import { device } from '../../styles/Responsive';

export const Menu = styled.div`
  position: fixed;
  display: inline-block;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  top: 0;
  right: 0;
  z-index: 999;
  background: ${NiceBlue};
  transform-origin: center right;
  transition: all 0.2s ease;
  transform: ${props =>
    props.state === 'entered' ? 'scale(1,1)' : 'scale(0,1)'};
`;

export const CloseIcon = styled.div`
  position: absolute;
  top: 35px;
  right: 35px;
  color: ${WhiteFour};
  font-size: 30px;
  cursor: pointer;

  @media ${device.tablet} {
    display: none;
  }
`;

export const SearchBar = styled.div`
  background: ${Bluish};
  width: 100px;
  height: 100%;
  position: sticky;
  top: 0;
  left: 0;
  float: left;

  ${CloseIcon} {
    display: none;
  }

  @media ${device.tablet} {
    width: 100%;
    height: 80px;
    z-index: 2;

    ${CloseIcon} {
      display: inline-block;
      top: 20px;
      right: 20px;
    }
  }
`;

export const SearchIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  color: ${WhiteFour};
  cursor: pointer;
  font-size: 30px;
`;

export const ShareIcon = styled.div`
  position: absolute;
  bottom: ${props => (props.bottom ? props.bottom : '20px')};
  left: 0;
  display: flex;
  align-self: flex-end;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 50px;
  color: ${WhiteFour};
  cursor: pointer;
  font-size: 20px;

  @media ${device.tablet} {
    display: none;
  }
`;

export const OptionsSection = styled.div`
  display: inline-block;
  position: relative;
  float: left;
  margin-left: 300px;
  min-height: 100%;
  padding-top: 100px;
  transform: ${props =>
    props.state === 'entered' ? 'translate(0,0)' : 'translate(200px,0)'};
  transition: transform 0.2s ease;
  transition-delay: 0.1s;
  padding-bottom: 100px;

  @media ${device.laptopL} {
    margin-left: 200px;
  }
  @media ${device.laptop} {
    margin-left: 150px;
  }

  @media ${device.tablet} {
    padding: 0 15px;
    margin-left: 0;
    margin-top: 50px;
    width: 100%;
    padding-bottom: 100px;
  }
`;

export const Option = styled.div`
  color: ${props => (props.active ? WhiteFour : DarkSkyBlue)};
  font-size: ${props => (props.smaller ? '16px' : '24px')};
  font-weight: ${props => (props.smaller ? '500' : 'bold')};
  margin-top: ${props => (props.smaller ? '30px' : '0')};
  padding: 10px 0;
  cursor: pointer;
  transition: color 0.2s ease;
  position: relative;
`;

export const SubMenu = styled.div`
  position: absolute;
  top: 6px;
  left: 270px;
  padding: 0 20px;
  z-index: 99;
  transform-origin: center right;
  transition: all 0.1s ease;
  transform: ${props =>
    props.state === 'entered' ? 'translate(0,0)' : 'translate(100px,0)'};

  @media ${device.tablet} {
    transform: ${props =>
      props.state === 'entered'
        ? 'translate(0, 0) scale(1, 1)'
        : 'translate(0, 0) scale(1, 0)'};
    transform-origin: top center;
    position: relative;
    left: 0;
    top: 0;
    &::before {
      display: none;
    }
  }

  &::before {
    content: '';
    position: absolute;
    height: 1px;
    width: 50px;
    background: ${WhiteFour};
    top: 20px;
    right: calc(100% + 20px);
  }
`;

export const SubOption = styled.div`
  color: ${props => (props.active ? WhiteFour : DarkSkyBlue)};
  font-size: 16px;
  font-weight: bold;
  padding: 10px 0;
  cursor: pointer;
  transition: color 0.2s ease;
`;

export const Copyright = styled.div`
  position: absolute;
  bottom: 30px;
  left: 0;
  font-size: 10px;
  font-weight: 500;
  color: ${WhiteFour};
  text-transform: uppercase;

  a,
  a:hover,
  a:focus,
  a:active {
    color: ${WhiteFour};
  }

  @media ${device.tablet} {
    left: 15px;
  }
`;

export const SearchInput = styled.input`
  display: inline-block;
  width: 500px;
  border: none;
  box-shadow: none;
  outline: none;
  outline-color: transparent;
  outline-width: 0;
  font-weight: bold;
  font-size: 40px;
  font-weight: bold;
  line-height: 1.25;
  color: ${WhiteFour};
  margin: 0;
  padding: 10px 20px;
  border-left: 1px solid ${WhiteFour};
  background: transparent;

  ::placeholder {
    color: ${Bluish};
    opacity: 1;
  }

  :-ms-input-placeholder {
    color: ${Bluish};
  }

  ::-ms-input-placeholder {
    color: ${Bluish};
  }

  &:hover,
  &:active,
  &:focus {
    outline: none;
    box-shadow: none;
    outline-width: 0;
    outline-color: transparent;
  }
`;

export const Social = styled.div`
  display: none;
  position: absolute;
  bottom: 30px;
  right: 15px;
  color: ${WhiteFour};
  font-size: 20px;

  svg {
    margin-left: 10px;
    cursor: pointer;
  }

  @media ${device.tablet} {
    display: inline-block;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuStyles.js